import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';
import { spliceOut } from 'components/sharpr/util/spliceOut';
import { KeywordMapValidator } from '../Vaildator/KeywordMapValidator';
import RunQueue from 'run-queue';

export function KeywordMapImportRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.KeywordMapImport', {
		url: '/keyword_maps/import',
		controllerAs: 'vm',
		controller: KeywordMapImportCtrl,
		templateUrl: '/ng/hub/KeywordMap/Import/KeywordMapImportCtrl.html?' + window.BUILD,
		resolve: {
			style: () => AssetManager.css('/ng/hub/KeywordMap/Import/KeywordMapImportCtrl.css'),
		},
	});
}

export class KeywordMapImportCtrl {
	constructor(modal, Api) {
		'ngInject';
		// save injections
		this.modal = modal;
		this.Api = Api;
		// setup map list
		this.maps = [];
	}

	remove(map) {
		spliceOut(this.maps, map);
	}

	save() {
		const scopeVars = {
			modal: this.modal,
			scope: this.scope,
			hubId: this.hub_id,
			accountId: this.account_id,
		};
		if (!KeywordMapValidator.isValidScope(scopeVars)) {
			// isValidScope will alert the problem
			return;
		}
		this.saving = {
			total: this.maps.length,
			complete: 0,
		};
		const queue = new RunQueue({ maxConcurrency: 2 });
		this.maps.forEach(map => {
			queue.add(1, () => {
				const data = {
					account_id: this.account_id,
					hub_id: this.hub_id,
					from_word: map.from_word,
					is_case_sensitive: map.is_case_sensitive,
					to_tag: map.to_tag,
				};
				return this.Api.post('/keyword_maps', data).then(
					() => {
						this.saving.complete++;
					},
					() => {}
				);
			});
		});
		queue.run().then(
			() => {
				// close modal and refresh keyword list
				this.$resolve({ refresh: true });
			},
			() => {}
		);
	}

	handlePaste() {
		this.pasted
			.trim()
			.split(/[\r\n]+/)
			.forEach(line => {
				const words = line
					.split(/\t+/)
					.map(word => word.trim().replace(/ +/, ' '))
					.filter(Boolean);
				for (let i = 0, len = words.length; i < len; i++) {
					for (let j = 0, len = words.length; j < len; j++) {
						if (i == j) {
							// don't map a word to itself
							continue;
						}
						let from_word = words[i];
						let to_tag = words[j];
						if (from_word == to_tag + 's' || from_word == to_tag) {
							// plural versions don't matter on to_tag
							continue;
						}
						this.maps.push({
							scope: this.scope,
							account_id: this.account_id,
							hub_id: this.hub_id,
							from_word,
							// case sensitive if vocabulary word has 2 or more capital letters
							// separated by zero or more of the following chars: & * / . space + -
							is_case_sensitive: /[A-Z][&*\/. +-]*[A-Z]/.test(from_word),
							to_tag,
						});
					}
				}
			});
		this.pasted = '';
	}
}
